export const createCopyrightText = (text) => {
  try {
    let copyrightText
    const currYear = new Date().getFullYear()
    const CURRRENT_YEAR_PLACEHOLDER = '{{currentYear}}'

    // safe check
    if (typeof text !== 'string') {
      return text
    }

    if (text.includes(CURRRENT_YEAR_PLACEHOLDER)) {
      copyrightText = text.replace(CURRRENT_YEAR_PLACEHOLDER, `${currYear}`)
      return copyrightText
    }
    // backward compatibility, has to be cleaned up later
    const separator = text.includes('-')
      ? '-' /* Unicode U+002d */
      : '–' /* Unicode U+2013 */
    const [first, ...rest] = text.split(separator)
    if (rest?.length) {
      copyrightText = `${first}${separator}${currYear}`
      return copyrightText
    }
    return text
  } catch (err) /* istanbul ignore next */ {
    return text
  }
}
